import { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import './Home.css';
import { Fade } from 'react-awesome-reveal';
import { TypeAnimation } from 'react-type-animation';
import CodeBackground from './CodeBackground';
import { FaTerminal } from '../../common/Icons';

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const showFab = isFocused && isMinimized;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 700); 
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <div className="home-container full-page-section" id="home">
      {isFocused && !isMinimized && (
        <div
          className="code-modal-overlay"
          onClick={() => {
            setIsFocused(false);
            setIsMinimized(false);
          }}
        />
      )}

      {!isMobile && (
        <CodeBackground
          isFocused={isFocused}
          setIsFocused={setIsFocused}
          isMinimized={isMinimized}
          setIsMinimized={setIsMinimized}
        />
      )}

      <div
        className={`code-fab ${showFab ? 'visible' : 'hidden'}`}
        onClick={() => setIsMinimized(false)}
      >
        <FaTerminal />
      </div>

      <div className={`home-foreground-content ${isFocused && !isMinimized ? 'hidden' : ''}`}>
        <h1 className="home-title">
          <Fade direction="up" triggerOnce={true} delay={100}>
            <span className="home-title-name">Carles Falcó Riera</span>
          </Fade>

          <Fade direction="up" triggerOnce={true} delay={100}>
            <div className='home-title-div'>
              <span className="home-title-sub">
                <TypeAnimation
                  sequence={[
                    'Senior Full Stack Engineer',
                    2000,
                    'Master in Cybersecurity & Privacy',
                    2000,
                    'DevSecOps Advocate',
                    2000,
                    'Cloud-Native Developer',
                    2000,
                  ]}
                  wrapper="span"
                  speed={50}
                  repeat={Infinity}
                  preRenderFirstString={true}
                  deletionSpeed={75}
                />
              </span>
            </div>
          </Fade>
        </h1>

        <Fade direction="up" triggerOnce={true} delay={100}>
          <p className="home-description">
            Driving Cloud Modernization & Development Security
            <br />
            <span className="home-stack">
              .NET | React | GCP | Cybersecurity
            </span>
          </p>
        </Fade>

        <Fade direction="up" triggerOnce={true} delay={100}>
          <Link
            to="contact"
            className="home-cta-button"
            smooth={true}
            offset={-70}
            duration={500}
          >
            Contact Me
          </Link>
        </Fade>
      </div>

    </div>
  );
};

export default Home;